import theme from '../base'

const list = {
  MuiListItem: {
    defaultProps: {
      ContainerComponent: 'div',
    },
    styleOverrides: {
      root: {
        color: theme.palette.neutral.main,
      },
      gutters: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
  },
  MuiListItemText: {
    defaultProps: {
      secondaryTypographyProps: {
        variant: 'subtitle1',
      },
    },
    styleOverrides: {
      root: {
        marginTop: 0,
        marginBottom: 0,

        '& .MuiTypography-root': {
          padding: theme.spacing(0.5),
        },
      },
      multiline: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(1),
        minWidth: theme.spacing(4.5),
        justifyContent: 'center',

        '& .MuiAvatar-root': {
          marginTop: theme.spacing(-0.5),
          marginBottom: theme.spacing(-0.5),
        },
      },
    },
  },
  MuiListItemSecondaryAction: {
    styleOverrides: {
      root: {
        color: theme.palette.neutral.main,
      },
    },
  },
}

export default list
